<template>
  <div class="min-h-screen flex flex-col bg-base-200">
    <Navbar />
    <main class="flex-1 container mx-auto px-4 py-8">
      <slot />
    </main>
    <Footer />
    <!-- Chatbot Component -->
    <SimpleChatbot />
  </div>
</template>

<script setup>
import Navbar from "~/components/Navbar.vue";
import Footer from "~/components/Footer.vue";
</script>

<style scoped></style>
